/**
 * User manuals for the JMO SYS application.
 *
 * Structure:
 *   manuals[persona][lang][moduleKey] = { title, overview, path, features[], tasks[], tips[], troubleshooting[] }
 *
 * Personas: 'admin' | 'technician' | 'client'
 * Langs:    'en'    | 'pt'
 *
 * Only the modules relevant to a persona are included in that persona's tree.
 * Titles double as sidebar labels in the Help page.
 */

import { adminManual } from "./adminManual";
import { technicianManual } from "./technicianManual";
import { clientManual } from "./clientManual";

export const manuals = {
  admin: adminManual,
  technician: technicianManual,
  client: clientManual,
};

// Order of modules displayed in the left rail for each persona
export const moduleOrder = {
  admin: [
    "dashboard", "inbox", "tickets", "schedule", "projects", "estimates", "receivables",
    "crew", "timeclock", "payroll", "hr",
    "purchasing", "material_requests", "materials", "material_trends",
    "suppliers", "subcontractors", "equipment",
    "financials", "finance",
    "clients", "properties",
    "daily_reports", "map",
    "permissions", "settings",
  ],
  technician: [
    "getting_started", "tickets", "schedule", "timeclock",
    "daily_reports", "material_requests", "map",
  ],
  client: [
    "getting_started", "portal_overview", "tickets", "projects", "estimates", "properties",
  ],
};

export const personaLabels = {
  en: {
    admin: "Administrator / Manager",
    technician: "Technician",
    client: "Client",
  },
  pt: {
    admin: "Administrador / Gerente",
    technician: "Técnico",
    client: "Cliente",
  },
};
